import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { partnerKeys } from '@/api/query-keys';
import {
  listPartnerContactsContract,
  type ListPartnerContactsResponse,
  type PartnerContact
} from '@bliks-io/contracts';

/** The signed-in partner rep's own call list. */
export function usePartnerContacts() {
  return useQuery({
    queryKey: partnerKeys.contacts(),
    queryFn: async ({ signal }): Promise<PartnerContact[]> => {
      const { data } = await apiClient.get<ListPartnerContactsResponse>(
        listPartnerContactsContract.path,
        { signal }
      );
      return data.data;
    }
  });
}
